import React, { useState } from 'react';
import { X, Building2 } from 'lucide-react';
import { createCity } from '../api/cityApi';

/**
 * Add-a-city modal. Creating a city just registers a new projectId (the slug
 * is derived from the name on the backend). The new city starts completely
 * empty — same UI, its own devices/content/schedules.
 */
export default function CreateCityModal({ onClose, onCreated }) {
  const [name, setName] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) { setError('Please enter a city name'); return; }
    setSubmitting(true);
    setError('');
    try {
      const city = await createCity({ displayName: name.trim() });
      if (onCreated) onCreated(city);
    } catch (err) {
      setError(err.message || 'Failed to create city');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ backgroundColor: '#fff', borderRadius: 16, padding: 24, maxWidth: 420, width: '90%', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
          <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'rgba(200,161,71,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Building2 size={20} color="#c8a147" />
          </div>
          <h3 style={{ flex: 1, margin: 0, fontSize: 18, fontWeight: 600, color: '#111827' }}>Add City</h3>
          <button onClick={onClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#6b7280' }}><X size={20} /></button>
        </div>

        <form onSubmit={submit}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>City name</label>
          <input
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Hyderabad"
            style={{ width: '100%', padding: '10px 12px', fontSize: 14, border: '1px solid #cbd5e1', borderRadius: 8, outline: 'none', boxSizing: 'border-box' }}
          />
          <p style={{ fontSize: 12, color: '#64748b', margin: '8px 0 0' }}>
            A new, empty city is created. Its devices, content, and schedules are completely separate from other cities.
          </p>

          {error && (
            <div style={{ marginTop: 12, padding: '8px 12px', background: 'rgba(193,71,71,0.08)', border: '1px solid rgba(193,71,71,0.2)', borderRadius: 8, color: '#c14747', fontSize: 13 }}>
              {error}
            </div>
          )}

          <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 20 }}>
            <button type="button" onClick={onClose} disabled={submitting}
              style={{ padding: '10px 20px', fontSize: 14, fontWeight: 500, color: '#374151', background: '#f3f4f6', border: 'none', borderRadius: 8, cursor: 'pointer' }}>
              Cancel
            </button>
            <button type="submit" disabled={submitting}
              style={{ padding: '10px 20px', fontSize: 14, fontWeight: 600, color: '#fff', background: '#c8a147', border: 'none', borderRadius: 8, cursor: submitting ? 'default' : 'pointer', opacity: submitting ? 0.7 : 1 }}>
              {submitting ? 'Creating…' : 'Create City'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
